import { Schema } from '../types/schema';

export const traverseSchema = (schema: Schema, callback: Function, parent?: Schema): Schema => {
	const result = callback(schema, parent);
	if (typeof result === 'object') {
		Object.keys(result).forEach((k) => {
			let node = result[k];
			try {
				if (!['string', 'number', 'boolean'].includes(typeof node)) {
					if (node.id) {
						node = traverseSchema(node, callback, schema);
					} else if (Array.isArray(node)) {
						node.forEach((i, j) => {
							node[j] = traverseSchema(i, callback, schema);
						});
						node = node.filter((i) => !!i);
					}
				}
			} catch (e) {}
			if (!node) {
				delete result[k]; // bye bye
			} else {
				result[k] = node;
			}
		});
	}
	return result;
};
